'use client'

import React from 'react'

import { FunnelFrame } from '@/components/landing/papr-funnel/styles'
import { LiveSignIn } from '@/components/landing/papr-funnel/auth-live'

export const dynamic = 'force-dynamic'

export default function SignInPage() {
  return (
    <React.Suspense fallback={null}>
      <FunnelFrame>
        <LiveSignIn />
      </FunnelFrame>
    </React.Suspense>
  )
}
